import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const requestDeleteSignature = () => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.DELETE,
    path: `/api/v1/profiles/doctor_profiles/delete_signature`,
  });
};

export default requestDeleteSignature;
